import { render, staticRenderFns } from "./cancellation-case.vue?vue&type=template&id=150cb934&scoped=true"
import script from "./cancellation-case.vue?vue&type=script&lang=ts"
export * from "./cancellation-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150cb934",
  null
  
)

export default component.exports